// extracted by mini-css-extract-plugin
module.exports = {"card":"trusted-shop_card__24BJh","fedex":"trusted-shop_fedex__KK4vz","trusted_shops_title":"trusted-shop_trusted_shops_title__vHU_l","image_card":"trusted-shop_image_card___B4U_"};